/* eslint-disable import/prefer-default-export */

export const CONFIGURABLE_FLOW_TOOL_IDS = [
  'create_negotiation',
  'move_negotiation',
  'assignment',
  'send_file',
  'trigger_whatsapp_flow',
  'purchase_intention',
  'create_order',
  'get_payment_link',
  'retrieve_products',
  'retailer_api_request',
  'get_customer_crm_data'
];

export const isConfigurableFlowToolId = (toolId) =>
  CONFIGURABLE_FLOW_TOOL_IDS.includes(toolId);
